/** Hyperbeat StakingCore — `BeHYPEToHYPE(uint256)` returns HYPE owed
 *  for a given beHYPE amount. Pass `1e18` to get the 1e18-scaled
 *  HYPE-per-beHYPE rate. Note the capitalisation: `BeHYPE` not
 *  `beHYPE`. */
export const HyperbeatStakingCoreAbi = [
  {
    name: 'BeHYPEToHYPE',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'beHYPEAmount' }],
    outputs: [{ type: 'uint256' }],
  },
] as const
